export interface TypedJsonResponse<T> extends Response {
  json<P = T>(): Promise<P>;
}

export function createUninitializedApiClient<T>(clientName: string) {
  return new Proxy(
    {},
    {
      get() {
        return () => {
          throw new Error(
            `${clientName} API client cannot be accessed outside ${clientName}ApiClientProvider component.`,
          );
        };
      },
    },
  ) as T;
}
